export enum InterviewType {
  TEXT = 'text',
  VIDEO = 'video',
  AUDIO = 'audio',
  IMAGE = 'image',
}

export enum ConversationStatus {
  DIGESTED = 'digested',
}

export enum AudioEventType {
  CAN_PLAY = 'canplay',
  WAITING = 'waiting',
  TIME_UPDATE = 'timeupdate',
  ENDED = 'ended',
  INPUT = 'input',
}

export enum ExportFileType {
  XLSX = 'xlsx',
  CSV = 'csv',
  TXT = 'txt',
}

export enum SearchParam {
  FILTER_ID = 'filter_id',
  SELECTED_TRANSCRIPT = 'selected_transcript',
  TRANSLATION_LANGUAGE = 'translation_language',
  TRANSCRIPTS_VIEW = 'transcripts_view',
  AI_SEARCH_QUESTION = 'ai_search_question',
  AI_SEARCH_QUESTION_PAGE = 'ai_search_question_page',
  CONVERSATION_FROM_QUESTIONS_TAB = 'conversation_from_questions_tab',
  COMPARISON_ID = 'comparison_id',
  QUESTION_ID = 'question_id',
}

export enum TableType {
  TRANSCRIPTS = 'transcripts',
  INCOMPLETE_TRANSCRIPTS = 'incomplete_transcripts',
  SCREENED_OUT_TRANSCRIPTS = 'screened_out_transcripts',
  TRANSLATED_TRANSCRIPTS = 'translated_transcripts',
  PER_QUESTION_TRANSCRIPTS = 'per_question_transcripts',
  BRANDINGS = 'brandings',
  USERS = 'users',
  PROJECTS = 'projects',
  CONVERSATIONS = 'conversations',
  WORKSPACES = 'workspaces',
  ORGANIZATIONS = 'organizations',
}

export enum SortingType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum PaginationAction {
  FIRST = 'first',
  PREVIOUS = 'previous',
  NEXT = 'next',
  LAST = 'last',
}

export enum LocalStorageKey {
  CURRENT_CONVERSATION_ID = 'current_conversation_id',
  SCREENING_QUESTION_INDEX = 'screening_question_index',
  SCREENING_QUESTION_DISQUALIFY_LINK = 'screening_question_disqualify_link',
  SCREENING_QUESTION_QUOTA_FULL_LINK = 'screening_question_quota_full_link',
  CURRENT_PROJECT_LANGUAGE = 'current_project_language',
  CURRENT_PROJECT_LANGUAGE_CODE = 'current_project_language_code',
  CHAT_SETTINGS = 'chat_settings',
  SCREENING_STATE = 'screening_state',
  CLIENT_IP = 'client_ip',
  POLL_CATEGORIES = 'poll_categories',
}

export enum CookieKey {
  TOKEN = 'token',
  MAIN_ORGANIZATION = 'main_organization',
  FALLBACK_WORKSPACE = 'fallback_workspace',
  REMEMBER_ME = 'remember_me',
}

export enum UrlQueryKey {
  MESSAGE = 'message',
}

export enum StaleTime {
  IMMEDIATE = 0,
  SHORT = 1000 * 10, // 10 seconds
  MEDIUM = 1000 * 30, // 30 seconds
  LONG = 1000 * 60, // 1 minute
  EXTENDED = 1000 * 60 * 3, // 3 minutes
  VERY_LONG = 1000 * 60 * 5, // 5 minutes
}

export enum QueryTag {
  USER = 'user',
  SINGLE_PROJECT_DATA = 'singleProjectData',
  PROJECTS = 'projects',
  WORKSPACE_MEMBERS = 'workspaceMembers',
  WORKSPACE_GROUPS = 'workspaceGroups',
  ORGANIZATIONS = 'organizations',
  ORGANIZATION_MEMBERS = 'organizationMembers',
  THEMES = 'themes',
  THEME = 'theme',
  QUESTION_TRANSCRIPTS = 'questionTranscripts',
  CONVERSATIONS = 'conversations',
  CONVERSATION = 'conversation',
  PROJECT_FILTERS = 'projectFilters',
  PROJECT_LANGUAGES = 'projectLanguages',
  TRANSLATION_PROGRESS = 'translationProgress',
  PROJECT_METADATA = 'projectMetadata',
  PROJECT_RESPONDENT_LOOKUP = 'projectRespondentLookup',
  INTERVIEW_QUESTIONS = 'interviewQuestions',
  INTERVIEW_QUESTION_INSIGHTS = 'interviewQuestionInsights',
  INTERVIEW_QUESTION_CATEGORIES = 'interviewQuestionCategories',
  INTERVIEW_OVERVIEW = 'interviewOverview',
  AI_SEARCH_RESULTS = 'aiSearchResults',
  NEW_CONVERSATIONS_COUNT = 'newConversationsCount',
  SCREENING_STATS = 'screeningStats',
  COMPARISONS = 'comparisons',
}
